import { useState } from 'react';
import FormInput from './FormInput';

/**
 * CurrencyInput - Specialized input for currency values
 * Auto-formats with commas, handles $ prefix
 */
const CurrencyInput = ({ value, onChange, ...props }) => {
  const formatCurrency = (val) => {
    if (!val) return '';
    const numericValue = val.toString().replace(/[^0-9]/g, '');
    return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '');
    onChange({ target: { value: rawValue } });
  };

  return (
    <FormInput
      type="text"
      value={formatCurrency(value)}
      onChange={handleChange}
      prefix="$"
      inputMode="numeric"
      {...props}
    />
  );
};

export default CurrencyInput;
